<script setup>
import FormInput from './../../pge-components/pge-input-text.vue';
import IconLockKey from './../../pge-components/icons/lock-key.vue';
</script>

<template>
  <div class="container">
    <div class="container__title">The Personal Details section is always included first.</div>
    <div class="container__inner">
      <div class="section-input">
        <icon-lock-key />
        <form-input disabled label="Section Name" placeholder="Personal Details" />
      </div>

      <div class="section-input__ml">
        <form-input disabled label="First Name" placeholder="First Name" />
        <form-input disabled label="Last Name" placeholder="Last Name" />
      </div>
      <div class="section-input__ml">
        <form-input disabled label="Email" placeholder="Email" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-2, 16px);
  align-self: stretch;
  margin-bottom: 40px !important;

  &__title {
    color: var(--ZZ_Old-ZZ_On-Surface-Gray-Variant, #49454F);
    font-feature-settings: 'liga' off, 'clig' off;

    font-family: Lato, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.4px;
  }

  &__inner {
    display: flex;
    padding-right: var(--spacing-1, 8px);
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;

    .section-input {
      display: flex;
      align-items: center;
      gap: var(--spacing-2, 16px);
      align-self: stretch;
      background-color: white;

      &__ml {
        display: flex;
        padding: var(--spacing-0, 0px) var(--spacing-5, 40px) var(--spacing-0, 0px) var(--spacing-10, 80px);
        justify-content: center;
        align-items: flex-start;
        gap: var(--spacing-5, 40px);
        align-self: stretch;
        background-color: white;
      }
    }
  }
}
</style>